module.exports = __webpack_public_path__ + "img/icon_attribute_mysterious_64.6f412be0.png";